(() => {
  'use strict';
  const storageKey = 'gorobei_language_preference';
  const checkedKey = 'gorobei_geo_language_checked';
  const selectors = Array.from(document.querySelectorAll('[data-gf-language-switcher]'));
  if (!selectors.length) return;
  const switcher = selectors[0];
  const form = switcher.querySelector('form');
  if (!form) return;
  const input = form.querySelector('input[name="language_code"]');
  const buttons = Array.from(switcher.querySelectorAll('[data-gf-language]'));
  if (!input || !buttons.length) return;
  const current = (switcher.dataset.activeLocale || '').toLowerCase().slice(0, 2);
  const isAvailable = (lang) => buttons.some(button => button.dataset.gfLanguage === lang && !button.disabled);
  const readSetting = (key) => {
    try { return localStorage.getItem(key); } catch (_) { return null; }
  };
  const saveSetting = (key, value) => {
    try { localStorage.setItem(key, value); } catch (_) {}
  };
  const sessionGet = (key) => {
    try { return sessionStorage.getItem(key); } catch (_) { return null; }
  };
  const sessionSet = (key, value) => {
    try { sessionStorage.setItem(key, value); } catch (_) {}
  };
  const submitLanguage = (lang) => {
    if (!['es', 'en'].includes(lang) || !isAvailable(lang) || lang === current) return;
    input.value = lang;
    form.submit();
  };
  buttons.forEach(button => button.addEventListener('click', () => {
    if (button.disabled) return;
    const lang = button.dataset.gfLanguage;
    if (!isAvailable(lang)) return;
    saveSetting(storageKey, lang);
    sessionSet(checkedKey, '1');
    submitLanguage(lang);
  }));
  if (window.Shopify && window.Shopify.designMode) return;
  if (sessionGet(checkedKey) === '1') return;
  sessionSet(checkedKey, '1');
  const preferred = readSetting(storageKey);
  if (preferred === 'es' || preferred === 'en') {
    submitLanguage(preferred);
    return;
  }
  const route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const endpoint = route.replace(/\/?$/, '/') + 'browsing_context_suggestions.json?country%5Benabled%5D=true&language%5Benabled%5D=false';
  fetch(endpoint, {credentials: 'same-origin', headers: {Accept: 'application/json'}})
    .then(response => { if (!response.ok) throw new Error('Geo unavailable'); return response.json(); })
    .then(data => {
      const country = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      if (!country || typeof country !== 'string') return;
      const recommended = country.toUpperCase() === 'ES' ? 'es' : 'en';
      if (isAvailable(recommended)) submitLanguage(recommended);
    })
    .catch(() => {});
})();
